import {
  getFeatureAccessInsights,
  getFeatureAccessInsightsStatus,
} from '@ms/yammer-data/dist/domains/featureAccessInsights/selectors';

import { useSelector } from '../useSelector';

type UseFeatureAccessInsightsStatus = () => ReturnType<typeof getFeatureAccessInsightsStatus>;
export const useFeatureAccessInsightsStatus: UseFeatureAccessInsightsStatus = () =>
  useSelector(getFeatureAccessInsightsStatus);

type UseFeatureAccessInsights = () => ReturnType<typeof getFeatureAccessInsights>;
/**
 * @deprecated PERFORMANCE This returns an entity object which will force re-renders if any API call causes it
 * to be updated. This should be replaced with a `useFeatureAccessInsightsField` selector.
 */
export const useFeatureAccessInsights: UseFeatureAccessInsights = () => useSelector(getFeatureAccessInsights);
